// extracted by mini-css-extract-plugin
export var description = "PageDescription-module--description--TvNVh";
export var descriptionWrap = "PageDescription-module--description-wrap--oChPC";
export var title = "PageDescription-module--title--hlOeG";